/**
 * This method returns "yes" if search results URL containts filters
 * @param  {string} pathName
 * @returns {string} "yes" if contains filters, "no" if contains no filters
 */
const isFilteredSearchResults = (pathName) => (pathName.replace(/\/products\//, '').replace(/(?=s_).+/, '') !== '' ? 'yes' : 'no');

export default isFilteredSearchResults;
